import { render, staticRenderFns } from "./ExpenseForm.vue?vue&type=template&id=2c621870&scoped=true&"
import script from "./ExpenseForm.vue?vue&type=script&lang=ts&"
export * from "./ExpenseForm.vue?vue&type=script&lang=ts&"
import style0 from "./ExpenseForm.vue?vue&type=style&index=0&id=2c621870&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c621870",
  null
  
)

export default component.exports